<template>
  <div class="main-box">
    <h1 v-intro="'<strong>Personen einladen</strong><br><br>Laden Sie eine Person ein, um ihr Leserecht auf ein Gesuch zu geben. Klicken Sie auf die drei Punkte in der Zeile des Gesuchs und in der Auswahl auf Personen einladen. Geben Sie die E-Mail Adresse ein und klicken Sie auf Einladen.'" v-intro-step="10" v-intro-position="'right'">
      Meine Übersicht</h1>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ $t('formError.unknownwError') }}
    </b-alert>
    <dx-data-grid
      :data-source="mergedList"
      :showColumnLines="false"
      :showRowLines="true"
      key-expr="antragId"
      :selection="{ mode: 'single' }"
      :hover-state-enabled="true"
      :column-auto-width="true"
      noDataText="Keine Einträge"
      :wordWrapEnabled="true"
      @selection-changed="onRowSelected"
      :ref="applicationListRef"
    >
      <dx-header-filter
        :visible="true"
      />
      <dx-filter-row
        :visible="true"
      />
      />
      <dx-search-panel
        :visible="true"
        :width="240"
        placeholder="Eintrag suchen"
      />
      <dx-column
        data-field="justAnIcon"
        caption=""
        cell-template="icon-template"
      />
      <dx-column
        data-field="status"
        caption="Status"
        cell-template="status-template"
        alignment="left"
      />
      <dx-column
        data-field="erstelltAm"
        caption="Erstellt"
        data-type="date"
        sort-order="desc"
      />
      <dx-column
        data-field="gesuchKey"
        caption="Gesuch"
      />
      <dx-column
        data-field="eigentuemer.fullname"
        caption="Eigentümer"
      />
      <dx-column
        data-field="adresse"
        caption="Adresse"
        width="180"
      />
      <dx-column
        data-field="gesuchArt"
        caption="Gesuchart"
        width="180"
      />
      <template #status-template="{ data }">
        <div class="state">
          <div>
            <span v-if="data.data.statusId === 12" v-b-tooltip.hover title="Laden Sie die Beilagen zum Gesuch hoch"><info-icon :size="18" fillColor="#DC1E50"/> {{data.data.status}}</span>
            <span v-else-if="data.data.statusId === 16" v-b-tooltip.hover title="Signatur ausstehend"><info-icon :size="18" fillColor="#DC1E50"/> {{data.data.status}}</span>
            <span v-else-if="data.data.statusId === 14"><info-icon :size="18" fillColor="#DC1E50"/> {{data.data.status}}</span>
            <span v-else-if="data.data.statusId === 3" v-b-tooltip.hover title="Zusicherung bereit zum Download"><info-icon :size="18" fillColor="#aecd60"/> {{data.data.status}}</span>
            <span v-else-if="[4,5,6].includes(data.data.statusId)"><info-icon :size="18" fillColor="#aecd60"/> {{data.data.status}}</span>
            <span v-else-if="data.data.statusId">{{data.data.status}}</span>
            <span v-else>Entwurf</span>
          </div>
        </div>
      </template>
      <template #icon-template="{ data }">
        <div>
          <span v-if="data.data.statusId" v-b-tooltip.hover title="Gesuch"><file-icon-dark :size="18"/></span>
          <span v-else v-b-tooltip.hover title="Entwurf"><file-icon-light :size="18"/></span>
        </div>
      </template>

      <dx-column
        caption=""
        cell-template="button-template"
        width="60px"
        type="buttons"
        :fixed="true"
        :showInColumnChooser="false"
      />
      <template #button-template="{ data }">
        <div v-if="data.data.statusId">
          <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret v-b-tooltip.hover title="Aktionen">
            <template #button-content>
              <span class="icon-more_vert"></span>
            </template>
            <b-dropdown-item :to="`/gesuch/${data.data.gesuchId}`">Detailansicht</b-dropdown-item>
            <b-dropdown-item
              v-b-toggle.sidebar-border
              @click="setPermissionApplicationId(data.data.gesuchId)"
            >
              Personen einladen
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div v-else>
          <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret v-b-tooltip.hover title="Aktionen">
            <template #button-content>
              <span class="icon-more_vert"></span>
            </template>
            <b-dropdown-item @click="editDraft(data.data.antragId)">Bearbeiten</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="deleteDraft(data.data.antragId)">Löschen</b-dropdown-item>
          </b-dropdown>
        </div>
      </template>-->

      <dx-paging
        :pageSize="pageSize"
        :page-index="pageIndex"
        @update:pageIndex="onPageChange($event)"
      />

    </dx-data-grid>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'
  import InfoIcon from 'vue-material-design-icons/InformationOutline.vue'
  import FileIconDark from 'vue-material-design-icons/FileDocument.vue'
  import FileIconLight from 'vue-material-design-icons/FileDocumentOutline.vue'
  import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxPaging
  } from 'devextreme-vue/data-grid'

  export default {
    data: () => ({
      hasUnknownError: false,
      hasError: false,
      errorMessage: '',
      pageSize: 10,
      applicationListRef: 'applicationList'
    }),
    created () {
      this.getApplications()
      this.getDrafts()
    },
    methods: {
      async getApplications () {
        this.isBusy = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('application/GET_MY_APPLICATIONS').then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async getDrafts () {
        this.isBusy = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('draft/GET_MY_DRAFTS').then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      setPermissionApplicationId (applicatonId) {
        this.$store.commit('permission/SET_PERMISSION_APPLICATION_ID', applicatonId)
        this.$store.commit('permission/SET_IS_DRAFT', false)
      },
      onRowSelected ({ selectedRowsData }) {
        if (selectedRowsData.length) {
          if (selectedRowsData[0].gesuchId) {
            const { gesuchId: applicationId } = selectedRowsData[0]
            this.$router.push({
              name: 'application-detail',
              params: {
                applicationId
              }
            }).catch((e) => {})
          } else {
            const { antragId } = selectedRowsData[0]
            this.editDraft(antragId)
            this.clearSelection()
          }
        }
      },
      clearSelection () {
        const dataGrid = this.$refs[this.applicationListRef].instance
        dataGrid.clearSelection()
      },
      async deleteDraft (draftId) {
        this.$bvModal.msgBoxConfirm('Möchten Sie den Entwurf wirklich löschen?', {
          title: 'Löschen',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Ja',
          cancelTitle: 'Nein',
          hideHeaderClose: false,
          centered: true
        })
          .then(async value => {
            if (value) {
              try {
                const { errors: errorsDelete } = await this.$store.dispatch('draft/DELETE_DRAFT', draftId)

                if (errorsDelete) {
                  return errorHandler(this, errorsDelete)
                }

                const { errors: errorsLatest } = await this.$store.dispatch('draft/GET_LATEST_UPDATED_DRAFT')

                if (errorsLatest) {
                  return errorHandler(this, errorsDelete)
                }
              } catch (err) {
                this.hasUnknownError = true
                console.error(err)
              }
            }
          })
          .catch(err => {
            console.error(err)
          })
      },
      async editDraft (draftId) {
        this.hasUnknownError = false
        this.hasError = false

        try {
          const { errors } = await this.$store.dispatch('draft/GET_DRAFT_BY_ID', draftId)

          if (errors) {
            return errorHandler(this, errors)
          }
        } catch (err) {
          this.hasUnknownError = true
          console.error(err)
        }
      },
      onPageChange (value) {
        this.$store.commit('application/SET_PAGE_INDEX', value)
      }
    },
    computed: {
      mergedList () {
        const newList = []
        for (const el in this.itemsApplications) {
          newList.push(this.itemsApplications[el])
        }
        const draftList = this.itemsDrafts
        for (const el in draftList) {
          draftList[el].status = 'Entwurf'
        }
        const modifiedItemsDraft = draftList.map(({
          gesuchsartBezeichnung: gesuchArt,
          antraegeEntwuerfeId: antragId,
          createdDate: erstelltAm,
          draftKey: gesuchKey,
          ...rest
        }) => ({
          gesuchArt,
          antragId,
          erstelltAm,
          gesuchKey,
          ...rest
        }))
        for (const el in modifiedItemsDraft) {
          newList.push(modifiedItemsDraft[el])
        }
        return newList
      },
      ...mapGetters({
        itemsApplications: 'application/MY_APPLICATIONS',
        itemsDrafts: 'draft/MY_DRAFTS'
      }),
      ...mapState({
        pageIndex: state => state.application.pageIndex
      })
    },
    components: {
      DxDataGrid,
      DxColumn,
      DxHeaderFilter,
      DxSearchPanel,
      DxFilterRow,
      InfoIcon,
      FileIconDark,
      FileIconLight,
      DxPaging
    }
  }
</script>

<style lang="scss" scoped>
  .search-col{
    padding-left: 0;
    padding-right: 0;
  }
  .table-btns a {
    line-height: 1;
  }
  .no-wrap{
    white-space: nowrap
  }
  .icon-more_vert{
    font-size: $font-size-lg * 1.5;
  }
  .state{
    display: flex;
    width: 100px;
    text-align: left;

    .icon{
      margin-right: 5px;

      .status-circle{
        display: block;
        width: 15px;
        height: 15px;
        background: $green;
        border-radius: 50%;
        margin-top: 3px;
      }
    }
  }
</style>
